<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" v-if="items[item].approvers">
        <people-picker-ms
          :label="$t('Approvers')"
          :title="$t('Approvers')"
          @update="args => this.handleUpdateApprovers(args)"
          class="mt-5"
          v-model="approvers"
          showRequired
          bulkUserAdd
        ></people-picker-ms>
      </v-col>
      <v-col cols="12" sm="6" v-if="items[item].fyis">
        <people-picker-ms
          :label="$t('FYIs')"
          :title="$t('FYIs')"
          class="mt-5"
          v-model="fyis"
          @update="args => this.handleUpdateFyis(args)"
          bulkUserAdd
        ></people-picker-ms>
      </v-col>
      <v-col cols="12" v-if="items[item].tasks">
        <TaskPicker
          class="mt-5"
          :tasks="tasks"
          @selectTask="selectTask"
          @deleteTask="deleteSelectedTask"
          :selectedTasks="attachedTo.tasks"
          @onClick="onTaskClick"
          @addTask="onTaskAdd"
        />
      </v-col>
    </v-row>
    <slot :attachedTo="attachedTo"></slot>
  </div>
</template>

<script>
import PeoplePickerMs from '@/components/peoplePicker/PeoplePickerMs'
import TaskPicker from '@/components/TaskPicker'

export default {
  name: 'FAT',
  components: {
    PeoplePickerMs,
    TaskPicker
  },
  props: {
    tasks: Array,
    attachedTo: Object,
    itemName: String
  },
  data() {
    return {
      approvers: this.attachedTo.approvers,
      fyis: this.attachedTo.fyis,
      items: {
        changeCategory: { tasks: true },
        relationships: { tasks: true, approvers: true, fyis: true },
        changeCategoryMocTypes: { tasks: true, approvers: true, fyis: true },
        approvalProcessTypes: { approvers: true, fyis: true }
      }
    }
  },
  methods: {
    selectTask(task) {
      if (!task) return
      this.attachedTo.tasks = this.attachedTo.tasks.filter(t => t !== task.clientID).concat(task.clientID)
    },
    deleteSelectedTask(task) {
      this.attachedTo.tasks = this.attachedTo.tasks.filter(t => t !== task.clientID)
    },
    onTaskClick(task) {
      this.$emit('onTaskClick', task)
    },
    onTaskAdd(search) {
      this.$emit('onTaskAdd', search, this.selectTask)
    },
    handleUpdateApprovers(usersAction) {
      this.attachedTo.approvers = usersAction.Users
    },
    handleUpdateFyis(usersAction) {
      this.attachedTo.fyis = usersAction.Users
    }
  },
  watch: {
    attachedTo(newValue) {
      this.approvers = newValue.approvers
      this.fyis = newValue.fyis
    }
  },
  computed: {
    item() {
      return this.itemName || this.attachedTo.item
    }
  }
}
</script>

<style scoped>
.v-list-item__title {
  padding-top: 12px;
  font-weight: bold;
}
</style>
